import Vue from 'vue'
import VueRouter from 'vue-router';
import VueClipboard from 'vue-clipboard2'
import i18n from '../more_review_app/i18n/index'
import store from '../more_review_app/store'
import {get, post, put } from '../more_review_app/api/http'
import App from '../more_review_app/App.vue'
import Home from '../more_review_app/pages/Home.vue'
import Complete from '../more_review_app/pages/Complete.vue'
import Guide from '../more_review_app/pages/Guide.vue'
import Order from '../more_review_app/pages/Order.vue'
import Address from '../more_review_app/pages/Address.vue'
import StepOne from '../more_review_app/pages/StepOne.vue'
import StepTwo from '../more_review_app/pages/StepTwo.vue'
import StepThree from '../more_review_app/pages/StepThree.vue'
import Choose from '../more_review_app/pages/Choose.vue'
import vueCountryRegionSelect from 'vue-country-region-select'

import 'bootstrap/dist/css/bootstrap.min.css'
import '../more_review_app/assets/css/common.scss'
import '../styles/application.scss'

const importAll = (r) => r.keys().map(r)
importAll(require.context('more_review_app/assets/images', false, /\.(png|jpe?g|svg)$/i))

Vue.use(VueRouter)
Vue.use(vueCountryRegionSelect)

// 定义全局变量
Vue.prototype.$get = get
Vue.prototype.$post = post
Vue.prototype.$put = put

// 判断是否是移动端
Vue.prototype.$isMobile = function() {
    let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
    return flag
}

const routes = [{
        path: '/',
        name: 'Home',
        component: Home
    },
    {
        path: '/complete', // 完成
        name: 'Complete',
        component: Complete
    },
    {
        path: '/guide', // 订单引导
        name: 'Guide',
        component: Guide
    },
    {
        path: '/order', // 订单
        name: 'Order',
        component: Order
    },
    {
        path: '/address', // 地址
        name: 'Address',
        component: Address
    },
    {
        path: '/stepOne', // 步骤一
        name: 'StepOne',
        component: StepOne
    },
    {
        path: '/stepTwo', // 步骤二
        name: 'StepTwo',
        component: StepTwo
    },
    {
        path: '/stepThree', // 步骤三
        name: 'StepThree',
        component: StepThree
    },
    {
        path: '/choose', // 选择商品
        name: 'Choose',
        component: Choose
    }
]

const router = new VueRouter({
    mode: 'hash',
    base: process.env.publicPath,
    routes
})

Vue.use(VueClipboard)
Vue.config.productionTip = false

document.addEventListener('DOMContentLoaded', () => {
    const app = new Vue({
        store,
        i18n,
        render: h => h(App),
        router,
    }).$mount()
    document.body.appendChild(app.$el)
})